import mutationTypes from '../constants/mutation-types';
import htmlMutation from './mutations/html-mutation';

const invertMutation = (mutation) => {
  switch (mutation.type) {
    case mutationTypes.HTML_MUTATION:
      return htmlMutation.invert(mutation);
    default:
      return null;
  }
};

export default invertMutation;
